<template>
  <RouterView name="header" v-slot="{ Component }">
    <!-- Padding mirrors the companion views so the header lines up with the
         content column instead of running to the viewport edge. -->
    <aside v-if="Component" class="container px-4 sm:px-6 print:mx-0 print:min-w-full">
      <component :is="Component" />
    </aside>
  </RouterView>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router';
</script>
